export const status_pedido = {
  pedido_nao_processado: 1,
  importado_com_sucesso: 2,
  pedido_rejeitado: 3,
  pedido_em_processamento: 4,
  pedido_cancelado_via_rotina_2596: 9,
};
